import React, { FC } from 'react';

import { Box } from '@mui/system';

import {
  adminActions,
  AdminLegendVariant,
  IAdminRequestedDetailsData,
  TypeOfBill,
  TypeOfSummary,
} from '@pharmaplan/common';

import PharmacistSummary from '../../../SelfService/PharmacistSummary';
import BillDetails from '../../../SelfService/BillDetails';
import strings from '../../../../localization';

import styles from './styles';

interface IViewRequestedCounter {
  event: IAdminRequestedDetailsData;
}

const { getRequestedDetails: getRequestedDetailsAction } = adminActions;

const ViewRequestedCounter: FC<IViewRequestedCounter> = ({ event }) => {
  const {
    counterHourlyRate,
    counterCost,
    counterTravelAllowance,
    counterMealAllowance,
    counterEmergencyFees,
    counterOtherAllowance,
    counterAccommodationAllowance,
    counterTravelAllowanceType,
    counterTravelAllowanceAmount,
    counterTravelAllowanceRatePerKm,
    counterAccommodationAllowanceType,
  } = event;

  const normalDetails = {
    ...event,
    hourlyRate: counterHourlyRate,
    cost: counterCost,
    travelAllowance: counterTravelAllowance,
    mealAllowance: counterMealAllowance,
    emergencyFees: counterEmergencyFees,
    otherAllowance: counterOtherAllowance,
    accommodationAllowance: counterAccommodationAllowance,
    travelAllowanceType: counterTravelAllowanceType,
    travelAllowanceAmount: counterTravelAllowanceAmount,
    travelAllowanceRatePerKm: counterTravelAllowanceRatePerKm,
    accommodationAllowanceType: counterAccommodationAllowanceType,
  };

  return (
    <>
      <Box sx={styles.cardContainer}>
        <PharmacistSummary
          customContainerStyle={styles.summaryContainer}
          event={event}
          summaryType={TypeOfSummary.workshiftDetails}
          type={AdminLegendVariant.requested}
        />
        <BillDetails
          successAction={getRequestedDetailsAction}
          billType={TypeOfBill.finalBill}
          event={event}
          isCounterOffer={false}
          showTitle={false}
        />
      </Box>
      <Box sx={styles.cardContainer}>
        <PharmacistSummary
          customContainerStyle={styles.summaryContainer}
          event={event}
          summaryType={TypeOfSummary.workshiftDetails}
          type={AdminLegendVariant.requested}
          isCounterOffer
          customTitle={strings.counterOfferDetails}
        />
        <BillDetails
          successAction={getRequestedDetailsAction}
          billType={TypeOfBill.counterOffer}
          event={normalDetails}
          showTitle={false}
          isCounterOffer={false}
        />
      </Box>
    </>
  );
};

export default ViewRequestedCounter;
